<template>
  <div
    id="app"
    class="wrapper"
    :class="{openHeader: $store.state.isHeaderMenuOpen, openFooter: $store.state.isFooterMenuOpen}"
  >
    <header :class="{hidden: isHeaderHidden, openMenu: subMenuOpenCompany || subMenuOpenSpace}">
      <div class="menu">
        <div class="menu__item">
          <router-link
            :to="{ name: 'CompanyHistory'}"
            v-if="!isMobile"
            :class="{active: currentPage == 'Company'}"
          >{{ _('menuCompany') }}</router-link>
          <span
            v-if="isMobile"
            class="link"
            :class="{active: currentPage == 'Company'}"
            @click="subMenuOpenCompany = !subMenuOpenCompany"
          >{{ _('menuCompany') }}</span>
        </div>
        <slide-up-down :active="currentPage == 'Company'" v-if="!isMobile">
          <div class="menu__sub">
            <div class="menu__item">
              <router-link
                :to="{ name: 'CompanyHistory'}"
                :class="{active: currentPage == 'Company' && currentSubPage == 'History'}"
              >{{ _('menuHistory') }}</router-link>
            </div>
            <div class="menu__item">
              <router-link
                :to="{ name: 'CompanyBrands'}"
                :class="{active: currentPage == 'Company' && currentSubPage == 'Brands'}"
              >{{ _('menuBrands') }}</router-link>
            </div>
            <div class="menu__item">
              <router-link
                :to="{ name: 'CompanyValues'}"
                :class="{active: currentPage == 'Company' && currentSubPage == 'Values'}"
              >{{ _('menuValues') }}</router-link>
            </div>
            <div class="menu__item">
              <router-link
                :to="{ name: 'CompanyPlans'}"
                :class="{active: currentPage == 'Company' && currentSubPage == 'Plans'}"
              >{{ _('menuPlans') }}</router-link>
            </div>
          </div>
        </slide-up-down>
        <transition
          enter-active-class="animated fadeIn"
          leave-active-class="animated fadeOut"
          v-if="isMobile"
        >
          <div class="menu__sub" v-if="subMenuOpenCompany && $store.state.isHeaderMenuOpen">
            <div>
              <div class="menu__sub__close" @click="subMenuOpenCompany = !subMenuOpenCompany"></div>
              <div class="menu__item">
                <router-link
                  :to="{ name: 'CompanyHistory'}"
                  :class="{active: currentPage == 'Company' && currentSubPage == 'History'}"
                >{{ _('menuHistory') }}</router-link>
              </div>
              <div class="menu__item">
                <router-link
                  :to="{ name: 'CompanyBrands'}"
                  :class="{active: currentPage == 'Company' && currentSubPage == 'Brands'}"
                >{{ _('menuBrands') }}</router-link>
              </div>
              <div class="menu__item">
                <router-link
                  :to="{ name: 'CompanyValues'}"
                  :class="{active: currentPage == 'Company' && currentSubPage == 'Values'}"
                >{{ _('menuValues') }}</router-link>
              </div>
              <div class="menu__item">
                <router-link
                  :to="{ name: 'CompanyPlans'}"
                  :class="{active: currentPage == 'Company' && currentSubPage == 'Plans'}"
                >{{ _('menuPlans') }}</router-link>
              </div>
            </div>
          </div>
        </transition>
        <div class="menu__item">
          <router-link
            :to="{ name: 'Advantages'}"
            :class="{active: currentPage == 'Advantages'}"
          >{{ _('menuAdvantages') }}</router-link>
        </div>
        <div class="menu__item">
          <router-link
            :to="{ name: 'SpaceOffice'}"
            v-if="!isMobile"
            :class="{active: currentPage == 'Space'}"
          >{{ _('menuSpace') }}</router-link>
          <span
            v-if="isMobile"
            class="link"
            :class="{active: currentPage == 'Space'}"
            @click="subMenuOpenSpace = !subMenuOpenSpace"
          >{{ _('menuSpace') }}</span>
        </div>
        <slide-up-down :active="currentPage == 'Space'" v-if="!isMobile">
          <div class="menu__sub">
            <div class="menu__item">
              <router-link
                :to="{ name: 'SpaceOffice'}"
                :class="{active: currentPage == 'Space' && currentSubPage == 'Office'}"
              >{{ _('menuOffice') }}</router-link>
            </div>
            <!--div class="menu__item">
                            <router-link :to="{ name: 'SpacePeople'}"   :class="{active: currentPage == 'Space' && currentSubPage == 'People'}">{{ _('menuPeople') }}</router-link>
            </div-->
          </div>
        </slide-up-down>
        <transition
          enter-active-class="animated fadeIn"
          leave-active-class="animated fadeOut"
          v-if="isMobile"
        >
          <div class="menu__sub" v-if="subMenuOpenSpace && $store.state.isHeaderMenuOpen">
            <div>
              <div class="menu__sub__close" @click="subMenuOpenSpace = !subMenuOpenSpace"></div>
              <div class="menu__item">
                <router-link
                  :to="{ name: 'SpaceOffice'}"
                  :class="{active: currentPage == 'Space' && currentSubPage == 'Office'}"
                >{{ _('menuOffice') }}</router-link>
              </div>
              <!--
                            <div class="menu__item">
                                <router-link :to="{ name: 'SpacePeople'}"   :class="{active: currentPage == 'Space' && currentSubPage == 'People'}">{{ _('menuPeople') }}</router-link>
              </div>-->
            </div>
          </div>
        </transition>
        <div class="menu__item">
          <!-- temporary off -->
          <!--<router-link :to="{ name: 'Vacancies'}"   :class="{active: currentPage == 'Vacancies' || currentPage == 'Vacancy' || currentPage == 'Request'}">{{ _('menuVacancies') }}</router-link>-->
          <a href="https://hh.ru/employer/3233751" target="_blank">{{ _('menuVacancies') }}</a>
        </div>
        <div class="menu__item">
          <router-link
            :to="{ name: 'Contacts'}"
            :class="{active: currentPage == 'Contacts'}"
          >{{ _('menuContacts') }}</router-link>
        </div>
      </div>
      <!-- temporary off -->
      <!--
            <div class="request" :class="{hidden: isRequestBtnHidden}">
                <router-link :to="{ name: 'Request', params: { vacancyId: 'vacancy' }}">{{ _('menuRequest') }}</router-link>
      </div>-->

      <div class="request" :class="{hidden: isRequestBtnHidden}">
        <a href="https://hh.ru/employer/3233751" target="_blank">{{ _('menuRequest') }}</a>
      </div>
    </header>

    <div
      class="mobile-header-menu-parts"
      v-if="isMobile"
      :class="{active: $store.state.isHeaderMenuOpen}"
    >
      <div class="mobile-header-menu-parts__part mobile-header-menu-parts__part-1"></div>
      <div class="mobile-header-menu-parts__part mobile-header-menu-parts__part-2"></div>
      <div class="mobile-header-menu-parts__part mobile-header-menu-parts__part-3"></div>
    </div>

    <router-link
      :to="{ name: 'Home'}"
      class="triangle"
      :class="{hidden: $store.state.isLogoHidden}"
    >
      <div class="logo-sub">{{ _('career') }}</div>
      <span class="logo"></span>
    </router-link>

    <div class="turn">{{ _('turn') }}</div>

    <span
      class="hamburger hamburger-header link"
      :class="hamburgerClass"
      @click="toggleHeaderMenu()"
    >
      <span></span>
      <span></span>
    </span>

    <transition
      :enter-active-class="$store.state.enterClassName"
      :leave-active-class="$store.state.leaveClassName"
    >
      <keep-alive exclude="Vacancy">
        <router-view @loaded="loaded"></router-view>
      </keep-alive>
    </transition>

    <footer :class="{hidden: isFooterHidden}">
      <span class="hamburger hamburger-close link" @click="toggleFooterMenu()" v-if="isMobile">
        <span></span>
        <span></span>
      </span>

      <div
        class="mobile-footer-menu-parts"
        v-if="isMobile"
        :class="{active: $store.state.isFooterMenuOpen}"
      >
        <div class="mobile-footer-menu-parts__part mobile-footer-menu-parts__part-1"></div>
        <div class="mobile-footer-menu-parts__part mobile-footer-menu-parts__part-2"></div>
      </div>

      <div class="menu-footer">
        <a href="https://support.delimobil.ru/hc/ru" target="_blank">{{ _('menuHelp') }}</a>
        <a :href="_('linkPolitics')" v-if="!isMobile" target="_blank">{{ _('menuPolitics') }}</a>
        <a :href="_('linkPolitics')" v-if="isMobile" target="_blank">{{ _('menuPoliticsMobile') }}</a>
        <a :href="_('linkDelimobil')" target="_blank">{{ _('menuDelimobil') }}</a>
        <router-link :to="_('linkDocuments')"> {{ _('menuDocuments') }} </router-link>
      </div>

      <div class="social">
        <a :href="_('linkVk')" target="_blank" class="social__icon social__icon-vk"></a>
        <a :href="_('linkTg')" target="_blank" class="social__icon social__icon-tg"></a>
      </div>
    </footer>

    <div
      class="link footer-mobile"
      @click="toggleFooterMenu()"
      v-if="isMobile"
      :class="{hidden: isMobileFooterHidden || $store.state.isHamburgerMobileActive}"
    >
      <div>
        <div class="hamburger hamburger-footer">
          <span></span>
          <span></span>
        </div>
      </div>
      <div>{{ _('info') }}</div>
    </div>

    <transition
      :enter-active-class="$store.state.enterClassNameVoile"
      :leave-active-class="$store.state.leaveClassNameVoile"
    >
      <!--<div class="voile full" v-if="$store.state.loader == true"><img :src="loaderSrc"></div>-->
      <div class="load" v-if="$store.state.loader == true">
        <div class="dot"></div>
        <div class="outline">
          <span></span>
        </div>
      </div>
    </transition>
  </div>
</template>

<style lang="less">
@import "./assets/css/loader.less";
@import "./assets/css/style.less";
</style>

<script>
import './assets/css/animate.css';
import { isMobile } from './mixins/isMobile';
import { functions } from './mixins/functions';

const $ = window.$ = window.jQuery = require('jquery');

export default {
  name: 'App',
  mixins: [isMobile, functions],

  data() {
    return {
      currentPage: 'Home',
      currentSubPage: '',
      isFooterHidden: false,
      isHeaderHidden: false,
      isHamburgerHidden: true,
      isMobileFooterHidden: false,
      isRequestBtnHidden: false,
      subMenuOpenSpace: false,
      subMenuOpenCompany: false
    };
  },

  computed: {
    loaderSrc: function() {
      return require('./assets/images/loader.svg');
    },
    hamburgerClass() {
      var _t = this;

      return {
        hidden:
          (_t.isHamburgerHidden && !_t.isMobile) ||
          _t.$store.state.isLogoHidden ||
          (_t.subMenuOpenSpace && _t.$store.state.isHeaderMenuOpen) ||
          (_t.subMenuOpenCompany && _t.$store.state.isHeaderMenuOpen),
        active: _t.$store.state.isHamburgerMobileActive
      };
    }
  },

  created() {
    let _t = this;

    _t.$store.dispatch('loadData', {
      page: 'App'
    });
    _t.$store.dispatch('loadVacancies');
  },

  mounted() {
    var UA = window.navigator.userAgent.toLowerCase();
    var isAndroid = UA && UA.indexOf('android') > 0;
    var isIOS = UA && /iphone|ipad|ipod|ios/.test(UA);

    if (isAndroid || isIOS) {
      $('.cursor').hide();
    }

    $('body').mousemove(function(e) {
      $('.cursor').css({
        left: parseInt(e.pageX) + 'px',
        top: parseInt(e.pageY) + 'px'
      });
    });

    $(document).on('mouseover mouseout', 'a, .link', function(event) {
      if (event.type === 'mouseover') {
        $('.cursor').addClass('hover');
      } else {
        $('.cursor').removeClass('hover');
      }
    });
  },

  methods: {
    toggleHeaderMenu() {
      var _t = this;

      if (_t.$store.state.isHamburgerMobileActive) {
        _t.$store.commit('toggleHamburgerMobile');
      } else {
        _t.$store.commit('toggleHeaderMenu');
        _t.$store.commit('hideFooterMenu');
      }
    },
    toggleFooterMenu() {
      var _t = this;
      _t.$store.commit('toggleFooterMenu');
      _t.$store.commit('hideHeaderMenu');
    },
    loaded(data) {
      var _t = this;

      _t.currentPage = data.page ? data.page : false;
      _t.currentSubPage = data.subPage ? data.subPage : false;
      _t.$store.commit('hideFooterMenu');
      _t.$store.commit('hideHeaderMenu');

      _t.isFooterHidden =
        data.isFooterHidden !== undefined ? data.isFooterHidden : false;
      _t.isHeaderHidden =
        data.isHeaderHidden !== undefined ? data.isHeaderHidden : false;
      _t.isHamburgerHidden = !_t.isHeaderHidden;

      _t.isMobileFooterHidden =
        data.isMobileFooterHidden !== undefined
          ? data.isMobileFooterHidden
          : false;
      _t.isRequestBtnHidden =
        data.isRequestBtnHidden !== undefined ? data.isRequestBtnHidden : false;
    },
    checkHamburgerVisibility() {
      var _t = this;

      if (_t.isMobile()) {
        _t.isHeaderHidden = true;
        _t.isFooterHidden = true;
        _t.isHamburgerHidden = false;
      } else {
        _t.isHamburgerHidden = !_t.isHeaderHidden;
      }

      return {};
    }
  }
};
</script>
